// extracted by mini-css-extract-plugin
module.exports = {"needHelp":"styles_needHelp__3Gc_c","roundedLink":"styles_roundedLink__1nTQo"};